import React, { useState, useEffect, useMemo } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  Box,
  useTheme,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";

import colors from "../../color";

const ActionPlanGrid = ({ data }) => {
  const priorityData = useMemo(() => {
    return data.filter((row) => row.priority !== null);
  }, [data]); // Dependency array

  const { t } = useTranslation();
  const theme = useTheme();

  // State for expanded panels
  const [expandedPanels, setExpandedPanels] = useState([]);

  // Update expandedPanels state when priorityData changes
  useEffect(() => {
    setExpandedPanels(Array(priorityData.length).fill(true));
  }, [priorityData]);

  // Handle accordion toggle
  const handleToggle = (index) => {
    setExpandedPanels((prevState) =>
      prevState.map((expanded, i) => (i === index ? !expanded : expanded))
    );
  };

  return (
    <Box>
      <Box>
        <Typography variant="subtitle1">{t("below_is_your_personalized")}</Typography>
      </Box>
      <Box
        sx={{
          marginTop: "10px",
        }}
      >
        {priorityData.map((item, index) => (
          <Accordion
            elevation={0}
            key={index}
            expanded={expandedPanels[index] || false}
            onChange={() => handleToggle(index)}
            sx={{
              margin: index === 0 ? "0px 0px 15px 0px" : "15px 0px 15px 0px",
              borderStyle: "solid",
              borderWidth: "1px",
              borderColor: theme.palette.secondary.main,
            }}
            disableGutters
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel${index}-content`}
              id={`panel${index}-header`}
              sx={{
                backgroundColor: theme.palette.secondary.light,
              }}
            >
              <Typography variant="h6">
                {t("text_priority")} {item.priority}: {t(item.barriers)}
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                padding: "0px",
              }}
            >
              {item.questions && item.questions.length > 0 ? (
                <List
                  sx={{
                    backgroundColor: colors.lightGray,
                    padding: "0px",
                  }}
                >
                  {item.questions.map((question, index) => (
                    <React.Fragment key={index}>
                      <ListItem>
                        <ListItemText
                          primary={`${index + 1}. ${t(question.questionText)}` || "No Data"}
                          primaryTypographyProps={{
                            variant: "body1",
                          }}
                        />
                      </ListItem>
                      {index < item.questions.length - 1 && <Divider />}
                    </React.Fragment>
                  ))}
                </List>
              ) : (
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: colors.textPrimary,
                    padding: "10px",
                    textAlign: "left",
                    fontStyle: "italic",
                  }}
                >
                  {t("no_strategies_selected")}

                </Typography>
              )}
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Box>
  );
};

export default ActionPlanGrid;
